import React from 'react'
import { Banner } from './banner'
import { EcommerceSec } from './ecommerceSec'

export const Ecommerce = () => {
  return (
    <>
    <Banner />
    <EcommerceSec />
    </>
  )
}
